import { useCallback } from "react";

import { Checkbox } from "@/components/ui/input/checkbox";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	showSubOptionName: boolean;
	showGuestTotalNumber: boolean;
	groupByOptionID: boolean;
	onChangeShowSubOptionName: (checked: boolean) => void;
	onChangeShowGuestTotalNumber: (checked: boolean) => void;
	onChangeGroupByOptionID: (checked: boolean) => void;
};

export const DisplaySettings = ({
	showSubOptionName,
	showGuestTotalNumber,
	groupByOptionID,
	onChangeShowSubOptionName,
	onChangeShowGuestTotalNumber,
	onChangeGroupByOptionID,
}: Props) => {
	const handleChangeShowSubOptionName = useCallback((checked: CheckedState) => {
		onChangeShowSubOptionName(checked === true);
	}, [ onChangeShowSubOptionName ]);

	const handleChangeShowGuestTotalNumber = useCallback((checked: CheckedState) => {
		onChangeShowGuestTotalNumber(checked === true);
	}, [ onChangeShowGuestTotalNumber ]);

	const handleChangeGroupByOptionID = useCallback((checked: CheckedState) => {
		onChangeGroupByOptionID(checked === true);
	}, [ onChangeGroupByOptionID ]);

	return (
		<div className="flex flex-wrap items-center gap-x-6 gap-y-2">
			<label className="flex cursor-pointer items-center gap-x-2">
				<Checkbox
					checked={showSubOptionName}
					onCheckedChange={handleChangeShowSubOptionName}
				/>
				<span className="text-xs">サブオプション名を表示</span>
			</label>
			<label className="flex cursor-pointer items-center gap-x-2">
				<Checkbox
					checked={showGuestTotalNumber}
					onCheckedChange={handleChangeShowGuestTotalNumber}
				/>
				<span className="text-xs">人数を表示</span>
			</label>
			<label className="flex cursor-pointer items-center gap-x-2">
				<Checkbox
					checked={groupByOptionID}
					onCheckedChange={handleChangeGroupByOptionID}
				/>
				<span className="text-xs">オプション（色）ごとにまとめて表示</span>
			</label>
		</div>
	);
};
